<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "FolhasObraModule"
    }
</script>

<style scoped>

</style>
